const CardClassification = ({ classification, expand }) => {
  return (
    <div className="card__classification">
      <h3>Classificação{expand && ':'}</h3>
      <p>{classification}</p>
    </div>
  );
};

export default CardClassification;
